import React from 'react';

type lineType = {
  isTop?: boolean;
  isNarrow?: boolean;
  isWide?: boolean;
  style?: any;
  top?: number;
  width: number;
  marginLeft?: number;
  paddingTop?: number;
  isExtraWide?: boolean;
  isThickLine?: boolean;
  children?: any;
  isBlack?: boolean;
};

const determinePaddingTop = (isTop, isNarrow, isWide, paddingTop) => {
  // if is the top line
  if (isTop) return '0px';
  // if a specific padding is passed in
  if (paddingTop) return paddingTop;
  if (isNarrow) return 14;
  if (isWide) return 30;
  return 19;
};

const GrayLine = ({
  isTop,
  isNarrow,
  style,
  width,
  marginLeft,
  isWide,
  paddingTop,
  isExtraWide,
  isThickLine,
  isBlack
}: lineType) => {
  let border = isWide || isBlack ? '2px solid #676464' : '2px solid lightGray';
  if (isExtraWide) border = '3px solid #676464';
  if (isThickLine) border = '3px solid #767676';
  const determinedPaddingTop = determinePaddingTop(isTop, isNarrow, isWide, paddingTop);
  return (
    <div
      className="grayLine"
      style={{
        ...style,
        borderBottom: border,
        paddingTop: determinedPaddingTop,
        width: `${width}px`,
        marginLeft: marginLeft
      }}
    />
  );
};

export default GrayLine;
